import { inject } from '@angular/core';
import { Router, CanActivateFn, ActivatedRouteSnapshot } from '@angular/router';

export const errorHandlerGuard: CanActivateFn = async (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const { queryParams } = route;

  if (queryParams['error']) {
    await router.navigate(['/auth/login'], {
      queryParams: {
        error: queryParams['error'],
        error_description: queryParams['error_description']
      },
      replaceUrl: true
    });
    return false;
  }

  return true;
};

